const createLoopingArray = (count) =>  Array.from({ length: count }, (_, index) => index + 1)

export default createLoopingArray;